import { unstable_batchedUpdates } from 'react-dom';
import { perfSpanStart, perfSpanEnd, perfSpanEndAfterPaint } from '../../../modules/perfTrace';

// 画面表示/レイアウト適用/データ読込/クリア/削除など入力画面のライフサイクル処理をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createEntryLifecycleService(deps) {
    const {
        AGRef,
        DeepCopy,
        DicVal,
        EDIT_UPDATE_TRACKING_PANEL_TYPES,
        EmptyPanel,
        EntrybodyRef,
        G_id,
        GridApi,
        GridData,
        SetGridApi,
        SetGridColApi,
        SetGridData,
        applyClientOnlyEntryDefaults,
        applyZaikoHyokaKbnFromShohinKbn,
        assignEntryDataCurrent,
        baseFieldsForInit,
        baseref,
        brandGroupInfoRequestSeqRef,
        buildHinbanGenkaStoredRows,
        buildHinbanWashDisplayRows,
        captureInitialPdtName,
        cfMargeUploadFiles,
        changestatus,
        columninfo,
        controlDateRef,
        controlDateRequestStateRef,
        controller,
        createBaseInitialData,
        currentPdtSizePatternCode,
        dispatch,
        displayInitialBlankDetailGridRow,
        edittingcode,
        entryFormStartedAtRef,
        entrydata,
        entrydataRef,
        entryrerender,
        fileRef,
        fnc,
        formatDateTimeForServer,
        formstatus,
        getglobaldata,
        gridlist,
        imageRef,
        importKakousijiEntriesFromHinbanData,
        initialHinbanInputControlDataRef,
        initialPdtcDetail220Ref,
        insertBrandHinbanField,
        insertCostRateField,
        insertFixedHinbanNumberingField,
        insertSubBrandField,
        isEmpty,
        isEnabled,
        isHinbanGenkaPanel,
        isHinbanWashPanel,
        kakousijiEntryCacheRef,
        kakousijiImportedSummaryRowsRef,
        lastBrandGroupBrandCodeRef,
        lastHbSeasonCodeRef,
        lastJyutakuSupplierCodeRef,
        lastLoadedKakousijiCodeRef,
        lastQrcMinHachuTaniKeyRef,
        lastQrcPackIrisuKeyRef,
        lastQrcSyohinBunruiCdKeyRef,
        lastQrcSyohinComentKeyRef,
        lastSeasonValueRef,
        loadBrandGroupInfo,
        loadHinbanFixEnableByBrand,
        loadJanSeasonCode,
        loadJyutakuSupplierInfo,
        loadKakousijiSummaryList,
        loadPdtSizePatternOptions,
        loadPdtSizePatternSizeOptions,
        loadPriceChangeEnable,
        loadQrcSyohinBunruiCd,
        loadQrcSyohinComent,
        loadSubBrandName,
        loadSustainableImageFromServer,
        loadUserAllowedBrandDepartment,
        locationstate,
        nametocolumn,
        normalizeKakousijiSampleDetailForDisplayByType,
        normalizePdtcDetailSections,
        observedJyutakuSupplierCodeRef,
        panel,
        pdtTenkaiCodeChangedAfterLoadRef,
        priceChangeEnableRef,
        primarykeys,
        refreshPdtSizePatternEditableState,
        rerender,
        resetSectionEdit,
        resolveBrandGroupBrandCode,
        resolveBrandHinbanField,
        resolveCostRateField,
        resolveFixedHinbanNumberingField,
        resolvePdtYearFromControlDate,
        resolveSubBrandField,
        scrollRef,
        seasonChangeTimerRef,
        setActiveKakousijiKey,
        setEntryGridRows,
        setGenkaCurrency,
        setGenkaCurrencyNo,
        setGenkaCurrencyOptions,
        setGenkaPattern,
        setGenkaPatternNo,
        setKakousijiSummaryList,
        setPdtItemCodesLoadVersion,
        setPriceFieldLocked,
        setSectionEditInfo,
        setSectionEditInfoFromData,
        setSectionEditInfoFromDataBulk,
        setSustainableImageFileEditing,
        setSustainableImageFileInputValue,
        setSustainableServerImageUrl,
        setedittingcode,
        setglobaldata,
        setimagelist,
        setpanel,
        settextfields,
        subkey,
        sustainableImageRequestSeqRef,
        syncHinbanGenkaCurrencyState,
        syncHinbanGenkaPatternByEntry,
        syncKakousijiSamplePanelsFromPdtc,
        syncMakerHyojyunJyodaiFromPrice,
        syncPdtYear,
        textfields,
        textfieldsall,
        updateSynFlg1DeleteDisabled
    } = deps;

    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);
        const renderedPanelType = String(DicVal(panel, "type", "")).trim();
        if (renderedPanelType === "200" || renderedPanelType === "210" || renderedPanelType === "220") {
            syncKakousijiSamplePanelsFromPdtc(25);
            if (renderedPanelType === "210") refreshPdtSizePatternEditableState();
        }

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        resetSectionEdit();
        clearform(code === "");
        entryFormStartedAtRef.current = code === "" ? "" : formatDateTimeForServer(new Date());
        // 既存データ表示時はここで本体・明細・添付をまとめて読み込む
        LoadData(code);
        return true;
    }
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(
            insertCostRateField(
                insertFixedHinbanNumberingField(
                    insertBrandHinbanField(
                        insertSubBrandField(newfields, resolveSubBrandField(textfieldsall)),
                        resolveBrandHinbanField(textfieldsall)
                    ),
                    resolveFixedHinbanNumberingField(textfieldsall)
                ),
                resolveCostRateField(textfieldsall)
            )
        );
    }
    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    function saveScrollPos() {
        if (isEmpty(EntrybodyRef.current)) return;
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    function restoreScrollPos() {
        try{
            if (isEmpty(EntrybodyRef.current) || scrollRef.current === null) return;
            EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    function buildStoredGridRows(panel, rows) {
        if (isHinbanWashPanel(panel)) return buildHinbanWashDisplayRows(rows);
        if (isHinbanGenkaPanel(panel)) return buildHinbanGenkaStoredRows(panel, rows);
        return rows;
    }
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                const gridApi = GridApi(gridlist[i]);
                if (isEmpty(gridApi)) continue;
                const rows = AGRef.current.GetDatasource(gridApi);
                SetGridData(gridlist[i], buildStoredGridRows(gridlist[i], rows));
            }
        } else {
            const gridApi = GridApi(panel);
            if (isEmpty(gridApi)) return;
            const rows = AGRef.current.GetDatasource(gridApi);
            SetGridData(panel, buildStoredGridRows(panel, rows));
        }
    }
    function LoadData(code) {
        if (code === "") return;
        const perfTotal = perfSpanStart('表示 合計(LoadData→描画完了)');
        const perfRequest = perfSpanStart('  1.通信往復 GetHinbanData');
        fnc.current.postaxios('hinbanmaster/GetHinbanData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    perfSpanEnd(perfRequest);
                    const perfApply = perfSpanStart('  2.反映処理 onSuccess本体');
                    try {
                        // React 17 はイベント外の setState をバッチしないため、
                        // ここを包まないと setEntryGridRows→AG Grid→effect→dispatch が同期再入して戻ってこない。
                        unstable_batchedUpdates(() => {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                let memo = nametocolumn("_memo");
                                if (memo !== "") {
                                    if (memo in row) data.data[memo] = row[memo];
                                }
                                let sticky = nametocolumn("_sticky");
                                if (sticky !== "") {
                                    if (sticky in row) data.data[sticky] = row[sticky];
                                }
                                let mytags = nametocolumn("_mytags");
                                if (mytags !== "") {
                                    if (mytags in row) data.data[mytags] = row[mytags];
                                }
                            }

                            fnc.current.margeMaster(data.master);
                            assignEntryDataCurrent(applyClientOnlyEntryDefaults(data.data), "LoadData");
                            pdtTenkaiCodeChangedAfterLoadRef.current = false;
                            initialHinbanInputControlDataRef.current = DeepCopy(entrydataRef.current);
                            updateSynFlg1DeleteDisabled(entrydataRef.current);
                            loadSustainableImageFromServer(entrydataRef.current);
                            loadPdtSizePatternOptions({ silent: true, autoSelectFirst: true });
                            loadPdtSizePatternSizeOptions(currentPdtSizePatternCode(entrydataRef.current), { silent: true });
                            loadSubBrandName({ targetData: entrydataRef.current });


                            setSectionEditInfoFromDataBulk(entrydataRef.current, EDIT_UPDATE_TRACKING_PANEL_TYPES);
                            applyZaikoHyokaKbnFromShohinKbn(entrydataRef.current);
                            syncMakerHyojyunJyodaiFromPrice(entrydataRef.current);
                            captureInitialPdtName(entrydataRef.current);
                            dispatch(entrydata({ ...entrydataRef.current }));
                            const normalizedDetail = normalizePdtcDetailSections(DicVal(data, "detail", {}));
                            data.detail = normalizedDetail;
                            initialPdtcDetail220Ref.current = Array.isArray(DicVal(normalizedDetail, "220", [])) ? DeepCopy(DicVal(normalizedDetail, "220", [])) : [];
                            //行データ
                            const deferPdtcSizeRows = !isEmpty(DicVal(entrydataRef.current, "PDT_TENKAICODE", ""));
                            for (let i = 0; i < gridlist.length; i++) {
                                if (normalizedDetail[gridlist[i].type] !== null && normalizedDetail[gridlist[i].type] !== undefined) {
                                    const detailType = String(DicVal(gridlist[i], 'type', '')).trim();
                                    if (deferPdtcSizeRows && detailType === "210") {
                                        displayInitialBlankDetailGridRow({ id: gridlist[i].id, type: gridlist[i].type });
                                        continue;
                                    }
                                    setEntryGridRows({ id: gridlist[i].id, type: gridlist[i].type }, normalizeKakousijiSampleDetailForDisplayByType(detailType, normalizedDetail[gridlist[i].type]));
                                }
                            }


                            syncKakousijiSamplePanelsFromPdtc();

                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            fileRef.current = data.files;
                            imageRef.current = data.images;
                            kakousijiEntryCacheRef.current = {};
                            lastLoadedKakousijiCodeRef.current = '';
                            importKakousijiEntriesFromHinbanData(DicVal(data.data, "kakousijiEntries", []));
                            loadPriceChangeEnable(code);
                            loadKakousijiSummaryList(resolveCurrentOppiCode(), { silent: true });
                            loadJanSeasonCode(DicVal(entrydataRef.current, "PDT_HBSEASONCD", ""), { silent: true, force: true });
                            loadBrandGroupInfo({ silent: true, clearOnNotFound: true, rerenderOnComplete: true });
                            loadHinbanFixEnableByBrand(resolveBrandGroupBrandCode(entrydataRef.current));
                            loadUserAllowedBrandDepartment(resolveBrandGroupBrandCode(entrydataRef.current));
                            loadJyutakuSupplierInfo({ silent: true, force: true });
                            loadQrcSyohinBunruiCd({ silent: true, force: true });
                            loadQrcSyohinComent({ silent: true, force: true });
                            syncHinbanGenkaCurrencyState(entrydataRef.current, true);
                            syncHinbanGenkaPatternByEntry(entrydataRef.current, code);
                            setPdtItemCodesLoadVersion((prev) => prev + 1);
                            dispatch(setimagelist(data.images));
                            rerender();
                        }
                        fnc.current.wait(false);
                        });
                        perfSpanEnd(perfApply);
                        perfSpanEndAfterPaint(perfTotal);
                    } catch (error) {
                        perfSpanEnd(perfApply, '(例外)');
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    // クリア済み entrydata を store 反映用に整える。全フィールドの columnid(と _nm)の
    // キーを必ず持たせ、値の無い項目は空文字にする。キーが欠けていると入力欄の
    // storeentrydata 同期エフェクトが「変更なし」としてスキップし、旧表示が残る。
    // textfieldsall は基本情報パネル(logpid=0)の項目のみのため、サイズ展開コード/
    // サイズパターン(210 パネルのヘッダ項目)などを取りこぼさないよう columninfo も走査する。
    function buildClearedStoreEntryData(baseData) {
        const cleared = { ...(isEmpty(baseData) ? {} : baseData) };
        const appendFieldKeys = (fields) => {
            (Array.isArray(fields) ? fields : []).forEach((field) => {
                const columnid = String(DicVal(field, "columnid", "")).trim();
                if (columnid === "") return;
                if (!(columnid in cleared)) cleared[columnid] = "";
                const nameKey = columnid + "_nm";
                if (!(nameKey in cleared)) cleared[nameKey] = "";
            });
        };
        appendFieldKeys(textfieldsall);
        appendFieldKeys(columninfo);
        return cleared;
    }
    function clearform(newform) {
        resetSectionEdit();
        setSectionEditInfo({});
        sustainableImageRequestSeqRef.current += 1;
        setSustainableServerImageUrl("");
        setSustainableImageFileEditing(false);
        setSustainableImageFileInputValue("");
        lastSeasonValueRef.current = "";
        lastHbSeasonCodeRef.current = "";
        lastQrcPackIrisuKeyRef.current = "";
        lastQrcMinHachuTaniKeyRef.current = "";
        lastQrcSyohinBunruiCdKeyRef.current = "";
        lastQrcSyohinComentKeyRef.current = "";
        lastBrandGroupBrandCodeRef.current = "";
        brandGroupInfoRequestSeqRef.current += 1;
        lastJyutakuSupplierCodeRef.current = "";
        observedJyutakuSupplierCodeRef.current = "";
        priceChangeEnableRef.current = null;
        setPriceFieldLocked(false);
        if (seasonChangeTimerRef.current !== null) {
            clearTimeout(seasonChangeTimerRef.current);
            seasonChangeTimerRef.current = null;
        }
        const clearformInitialData = createBaseInitialData(textfieldsall);
        assignEntryDataCurrent(clearformInitialData, "clearform");
        captureInitialPdtName(entrydataRef.current);
        // クリア結果を store と入力欄へ即時反映する。dispatch しないと store.entrydata が
        // 旧品番のまま残り、マウント済みの入力欄もローカル値を保持し続けるため、
        // ENTRY FORM→NEW や 一覧で行選択→NEW FORM の遷移で前のデータが表示されたままになる。
        // 入力欄の同期エフェクトは「キーが存在する項目」しか反映しないため、
        // 初期データに無い columnid も含めて全項目を空としてキーを立てて流す。
        dispatch(entrydata(buildClearedStoreEntryData(entrydataRef.current)));
        dispatch(entryrerender());
        imageRef.current = null;
        fileRef.current = null;
        initialPdtcDetail220Ref.current = [];
        initialHinbanInputControlDataRef.current = {};
        pdtTenkaiCodeChangedAfterLoadRef.current = false;
        scrollRef.current = null;
        kakousijiEntryCacheRef.current = {};
        kakousijiImportedSummaryRowsRef.current = [];
        lastLoadedKakousijiCodeRef.current = '';
        setKakousijiSummaryList([]);
        setActiveKakousijiKey("");
        setGenkaPatternNo(0);
        setGenkaPattern('');
        setGenkaCurrency('');
        setGenkaCurrencyNo('0');
        setGenkaCurrencyOptions([]);
        for (let i = 0; i < gridlist.length; i++) {
            // SetGridData は store の行参照を差し替えるだけで表示中の AG Grid には届かない。
            // マウント済みグリッド(カラー/サイズ/SKU/セットアイテム等)の行と、
            // 210 のヘッダ行(サイズ展開コード/サイズパターンの保持先)まで確実に消すため
            // grid API へも反映する setEntryGridRows で空にする。
            setEntryGridRows(gridlist[i], []);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            // 新規入力時だけ SQL 初期値を再取得して初期状態を作り直す
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: baseFieldsForInit(textfieldsall) },
            {
                onSuccess: function (data) {
                    for (let key in data.returnData) {
                        var col = textfieldsall.find(e => e.columnid === key);
                        if (!isEmpty(col)) col.initvalue = data.returnData[key];
                    }
                    if (entrydataRef.current === clearformInitialData) {
                        assignEntryDataCurrent(createBaseInitialData(textfieldsall), "clearform");
                        captureInitialPdtName(entrydataRef.current);
                        dispatch(entrydata(buildClearedStoreEntryData(entrydataRef.current)));
                        dispatch(entryrerender());
                    }
                    if (isEnabled(newform)) {
                        loadPriceChangeEnable(resolveCurrentOppiCode(), { shouldLog: true });
                        // syncNewFormPdtYear は年度が導出できない場合に再描画せず戻るため、
                        // ここで必ず再描画しておく(新規遷移時の残留表示防止)。
                        rerender();
                        syncNewFormPdtYear();
                        return;
                    }
                    rerender();
                },
            }, true
            )
        }
    }
    function Delete(finallycallback) {
        const oppiCode = String(DicVal(entrydataRef.current, "PDT_OPPICD", edittingcode)).trim();
        const param = {
            rowdata: [{ "rowid": oppiCode, "PDT_OPPICD": oppiCode }],
            controller: controller,
            code: oppiCode,
            data: {
                ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
                PDT_OPPICD: oppiCode
            }
        };
        fnc.current.postaxios("hinbanmaster/DeleteHinbanMaster", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(oppiCode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["Delete failed", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "Delete failed"
            }
        );
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function RowDataUpdated(api, data) {
        if (isEmpty(api)) return;
        if (isEmpty(data)) return;
        var visible = false;
        if (!isEmpty(data)) {
            visible = DicVal(data, "SHOWPICTURE", "0") === "1";
        }
        //画像表示の場合行の高さを変更
        if (visible) {
            api.setColumnWidths([{ key: "imageurl", newWidth: 80 }]);
            api.forEachNode(function (rowNode) {
                var url = DicVal(rowNode.data, "imageurl", "*");
                if (url !== '*') {  //画像読み込み済
                    rowNode.setRowHeight(60);
                }
            });
            api.onRowHeightChanged();
        }
    }
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    function moreImage(e, mode, src) {
        if (mode !== 2) return;
        const api = e.api;
        var current = e.data["PDT_OPPICD"];
        var target = baseref.current.GetAfterFilterData();
        var index = target.findIndex(e => e["PDT_OPPICD"] === current);
        if (index === -1) return;
        var codes = [];
        //指定行から100件のPS品番を取得
        for (let r = index; r < target.length; r++) {
            if (codes.length > 100) break;
            if (Object.hasOwn(target[r], 'imageurl')) continue;     //画像読み込み済
            codes.push(target[r]["PDT_OPPICD"]);
        }
        if (codes.length < 100 && index !== 0) {
            //前を検索
            for (let r = index - 1; r >= 0; r--) {
                if (codes.length > 100) break;
                if (Object.hasOwn(target[r], 'imageurl')) break;     //画像読み込み済が見つかったところで終了
                codes.push(target[r]["PDT_OPPICD"]);
            }
        }
        //画像URLを取得
        fnc.current.postaxios('hinbanmaster/GetImageUrl',
            {
                controller: controller,
                subkey: subkey,
                keys: codes,
            },
            {
                onSuccess: function (data) {
                    target.forEach(node => {
                        const item = Object.keys(data.data).filter(key => key === node["PDT_OPPICD"]);  //
                        if (item.length !== 0) {
                            let rowid = node["rowid"];
                            const rowNode = api.getRowNode(rowid);
                            rowNode.setDataValue("imageurl", data.data[item[0]]);
                            rowNode.setRowHeight(60);
                        }
                    });
                    api.onRowHeightChanged();
                    fnc.current.wait(false);
                },
            }
        );
    }
    function loadControlDate(callback, errorCallback) {
        // 制御日付はセッション中不変の業務日付のため、一度取得したらキャッシュから返す。
        // 取得中に重ねて呼ばれた場合は待ち行列に相乗りさせ、リクエストを1本に束ねる
        // (NEW FORM 表示時に formstatus effect と clearform→syncNewFormPdtYear の
        //  2系統が別タイミングで取得し、GetControlDate が2回飛んでいた対策)。
        const state = controlDateRequestStateRef.current;
        if (!isEmpty(state.value)) {
            if (!isEmpty(callback)) callback(state.value, state.returnData);
            return;
        }
        if (Array.isArray(state.waiters)) {
            state.waiters.push({ callback: callback, errorCallback: errorCallback });
            return;
        }
        state.waiters = [{ callback: callback, errorCallback: errorCallback }];
        fnc.current.postaxios("hinbanmaster/GetControlDate", null,
            {
                onSuccess: function (data) {
                    state.value = data.request;
                    state.returnData = data.returnData;
                    const waiters = Array.isArray(state.waiters) ? state.waiters : [];
                    state.waiters = null;
                    waiters.forEach((waiter) => {
                        if (!isEmpty(waiter.callback)) waiter.callback(state.value, state.returnData);
                    });
                },
                onError: function (data) {
                    // 失敗時はキャッシュせず、次回の呼び出しで再取得する
                    const waiters = Array.isArray(state.waiters) ? state.waiters : [];
                    state.waiters = null;
                    waiters.forEach((waiter) => {
                        if (!isEmpty(waiter.errorCallback)) {
                            waiter.errorCallback(data);
                            return;
                        }
                        let msg = "ControlDateの取得に失敗しました";
                        if (!isEmpty(data.errDescription)) {
                            msg = data.errDescription;
                        }
                        fnc.current.warnmsg(msg);
                    });
                }
            }, true
        );
    }
    function refreshControlDate(shouldUpdatePdtYear, errorCallback) {
        loadControlDate((controlDate) => {
            controlDateRef.current = controlDate;
            if (shouldUpdatePdtYear) {
                syncPdtYear(controlDate);
                return;
            }
            dispatch(entryrerender());
        }, errorCallback);
    }
    function syncNewFormPdtYear() {
        loadControlDate((controlDate) => {
            controlDateRef.current = controlDate;
            if (isEmpty(entrydataRef.current)) return;
            const year = resolvePdtYearFromControlDate(controlDate, DicVal(entrydataRef.current, "PDT_SEASONCD", ""));
            if (isEmpty(year)) return;
            assignEntryDataCurrent({
                ...entrydataRef.current,
                PDT_YEAR: year
            }, "syncNewFormPdtYear");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            rerender();
        });
    }
    function resolveCurrentOppiCode() {
        if (!isEmpty(entrydataRef.current)) {
            const entryOppiCode = String(DicVal(entrydataRef.current, "PDT_OppiCd", "")).trim();
            if (!isEmpty(entryOppiCode)) return entryOppiCode;
            for (let i = 0; i < primarykeys.length; i++) {
                const primaryCode = String(DicVal(entrydataRef.current, primarykeys[i], "")).trim();
                if (!isEmpty(primaryCode)) return primaryCode;
            }
        }
        return String(isEmpty(edittingcode) ? "" : edittingcode).trim();
    }

    return {
        callshow,
        onFirstDataRendered,
        Show,
        SetLayout,
        showpanel,
        saveScrollPos,
        restoreScrollPos,
        buildStoredGridRows,
        storeRowData,
        LoadData,
        SetPLData,
        clearform,
        Delete,
        Getrowid,
        RowDataUpdated,
        ListlockCell,
        fileuploaded,
        moreImage,
        loadControlDate,
        refreshControlDate,
        syncNewFormPdtYear,
        resolveCurrentOppiCode
    };
}
